import alt from 'alt'
import { createStore } from 'alt-utils/lib/decorators'
import { UserFeedbackActions } from 'actions'

@createStore(alt)
export default class UserFeedbackStore {
  constructor() {
    this.state = {
      isEnjoying: null,
      willReview: null,
      willFeedback: null,
      feedbackDismissed: false
    }

    this.bindActions(UserFeedbackActions)

    let feedbackDismissedPersisted = localStorage.getItem('feedbackDismissed')
    if (feedbackDismissedPersisted !== null)
      this.state.feedbackDismissed = JSON.parse(feedbackDismissedPersisted)
  }

  static displayName = 'UserFeedbackStore'

  setEnjoying(isEnjoying) {
    this.setState({ isEnjoying })
  }

  setWillReview(willReview) {
    this.setState({ willReview })
    this.setDismissed(true)
  }

  setWillFeedback(willFeedback) {
    this.setState({ willFeedback })
    this.setDismissed(true)
  }

  setDismissed(isDismissed) {
    localStorage.setItem('feedbackDismissed', isDismissed)
    this.setState({ feedbackDismissed: isDismissed })
  }
}



// WEBPACK FOOTER //
// ./app/stores/UserFeedbackStore.js